/**
 * Calculates the horizontal distance (in %) between a mouse event (click, move, etc.) and a reference element passed.
 * @param e MouseEvent
 * @param referenceElement HTMLElement used as a reference for distance calculation.
 * @param limit Boolean used to determined if offset should be limited by referenceElement. (default: true)
 */
export function calculateDistance(
  e: MouseEvent | TouchEvent,
  referenceElement: HTMLElement | null,
  limit: boolean = true
) {
  if (!referenceElement) return 0;

  let clientX = 0;

  if (e instanceof MouseEvent) {
    clientX = e.clientX;
  } else if (e instanceof TouchEvent && e.touches.length) {
    clientX = e.touches[0].clientX;
  } else if (e instanceof TouchEvent && e.changedTouches.length) {
    clientX = e.changedTouches[0].clientX;
  }

  const elementRect = referenceElement.getBoundingClientRect();

  let offset = ((clientX - elementRect.left) / elementRect.width) * 100;

  if (limit) {
    if (offset < 0) offset = 0;
    if (offset > 100) offset = 100;
  }

  return offset || 0;
}
